// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * ----------------- Booking Link Tracking Logs Request/Response -----------------
 */
export var ScheduleRequestSource;
(function (ScheduleRequestSource) {
    ScheduleRequestSource["UNKNOWN"] = "UNKNOWN";
    ScheduleRequestSource["ONLINE"] = "ONLINE";
    ScheduleRequestSource["GOOGLE_BUSINESS_PROFILE"] = "GOOGLE_BUSINESS_PROFILE";
    ScheduleRequestSource["MESSAGING"] = "MESSAGING";
    ScheduleRequestSource["QUICKFILL"] = "QUICKFILL";
    ScheduleRequestSource["SCHEDULE_BOT"] = "SCHEDULE_BOT";
    ScheduleRequestSource["SCHEDULE_AUTOMATED_CALL"] = "SCHEDULE_AUTOMATED_CALL";
    ScheduleRequestSource["AUTO_MESSAGING"] = "AUTO_MESSAGING";
    ScheduleRequestSource["BULK_MESSAGING"] = "BULK_MESSAGING";
    ScheduleRequestSource["BULK_EMAIL"] = "BULK_EMAIL";
    ScheduleRequestSource["EMAIL"] = "EMAIL";
    ScheduleRequestSource["WEBSITE"] = "WEBSITE";
    ScheduleRequestSource["OTHER"] = "OTHER";
})(ScheduleRequestSource || (ScheduleRequestSource = {}));
export var ScheduleRequestSource_index;
(function (ScheduleRequestSource_index) {
    ScheduleRequestSource_index[ScheduleRequestSource_index["UNKNOWN"] = 0] = "UNKNOWN";
    ScheduleRequestSource_index[ScheduleRequestSource_index["ONLINE"] = 1] = "ONLINE";
    ScheduleRequestSource_index[ScheduleRequestSource_index["GOOGLE_BUSINESS_PROFILE"] = 2] = "GOOGLE_BUSINESS_PROFILE";
    ScheduleRequestSource_index[ScheduleRequestSource_index["MESSAGING"] = 3] = "MESSAGING";
    ScheduleRequestSource_index[ScheduleRequestSource_index["QUICKFILL"] = 4] = "QUICKFILL";
    ScheduleRequestSource_index[ScheduleRequestSource_index["SCHEDULE_BOT"] = 5] = "SCHEDULE_BOT";
    ScheduleRequestSource_index[ScheduleRequestSource_index["SCHEDULE_AUTOMATED_CALL"] = 6] = "SCHEDULE_AUTOMATED_CALL";
    ScheduleRequestSource_index[ScheduleRequestSource_index["AUTO_MESSAGING"] = 7] = "AUTO_MESSAGING";
    ScheduleRequestSource_index[ScheduleRequestSource_index["BULK_MESSAGING"] = 8] = "BULK_MESSAGING";
    ScheduleRequestSource_index[ScheduleRequestSource_index["BULK_EMAIL"] = 9] = "BULK_EMAIL";
    ScheduleRequestSource_index[ScheduleRequestSource_index["EMAIL"] = 10] = "EMAIL";
    ScheduleRequestSource_index[ScheduleRequestSource_index["WEBSITE"] = 11] = "WEBSITE";
    ScheduleRequestSource_index[ScheduleRequestSource_index["OTHER"] = 12] = "OTHER";
})(ScheduleRequestSource_index || (ScheduleRequestSource_index = {}));
export var ScheduleRequestStatus;
(function (ScheduleRequestStatus) {
    ScheduleRequestStatus["UNKNOWNSTATUS"] = "UNKNOWNSTATUS";
    ScheduleRequestStatus["PENDING"] = "PENDING";
    ScheduleRequestStatus["ACCEPTED"] = "ACCEPTED";
    ScheduleRequestStatus["REJECTED"] = "REJECTED";
})(ScheduleRequestStatus || (ScheduleRequestStatus = {}));
export var ScheduleRequestStatus_index;
(function (ScheduleRequestStatus_index) {
    ScheduleRequestStatus_index[ScheduleRequestStatus_index["UNKNOWNSTATUS"] = 0] = "UNKNOWNSTATUS";
    ScheduleRequestStatus_index[ScheduleRequestStatus_index["PENDING"] = 1] = "PENDING";
    ScheduleRequestStatus_index[ScheduleRequestStatus_index["ACCEPTED"] = 2] = "ACCEPTED";
    ScheduleRequestStatus_index[ScheduleRequestStatus_index["REJECTED"] = 3] = "REJECTED";
})(ScheduleRequestStatus_index || (ScheduleRequestStatus_index = {}));
export var ScheduleLinkTypeMeta;
(function (ScheduleLinkTypeMeta) {
    ScheduleLinkTypeMeta["STRING"] = "STRING";
    ScheduleLinkTypeMeta["BOOLEAN"] = "BOOLEAN";
    ScheduleLinkTypeMeta["INTEGER"] = "INTEGER";
    ScheduleLinkTypeMeta["SINGLE_SELECT"] = "SINGLE_SELECT";
    ScheduleLinkTypeMeta["MULTI_SELECT"] = "MULTI_SELECT";
    ScheduleLinkTypeMeta["OBJECT"] = "OBJECT";
})(ScheduleLinkTypeMeta || (ScheduleLinkTypeMeta = {}));
export var ScheduleLinkTypeMeta_index;
(function (ScheduleLinkTypeMeta_index) {
    ScheduleLinkTypeMeta_index[ScheduleLinkTypeMeta_index["STRING"] = 0] = "STRING";
    ScheduleLinkTypeMeta_index[ScheduleLinkTypeMeta_index["BOOLEAN"] = 1] = "BOOLEAN";
    ScheduleLinkTypeMeta_index[ScheduleLinkTypeMeta_index["INTEGER"] = 2] = "INTEGER";
    ScheduleLinkTypeMeta_index[ScheduleLinkTypeMeta_index["SINGLE_SELECT"] = 3] = "SINGLE_SELECT";
    ScheduleLinkTypeMeta_index[ScheduleLinkTypeMeta_index["MULTI_SELECT"] = 4] = "MULTI_SELECT";
    ScheduleLinkTypeMeta_index[ScheduleLinkTypeMeta_index["OBJECT"] = 5] = "OBJECT";
})(ScheduleLinkTypeMeta_index || (ScheduleLinkTypeMeta_index = {}));
export var WebAssistantFeature;
(function (WebAssistantFeature) {
    WebAssistantFeature["WEB_ASSISTANT_FEATURE_UNSPECIFIED"] = "WEB_ASSISTANT_FEATURE_UNSPECIFIED";
    WebAssistantFeature["WEB_ASSISTANT_FEATURE_WEB_CONTACT"] = "WEB_ASSISTANT_FEATURE_WEB_CONTACT";
    WebAssistantFeature["WEB_ASSISTANT_FEATURE_ONLINE_SCHEDULING"] = "WEB_ASSISTANT_FEATURE_ONLINE_SCHEDULING";
})(WebAssistantFeature || (WebAssistantFeature = {}));
export var WebAssistantFeature_index;
(function (WebAssistantFeature_index) {
    WebAssistantFeature_index[WebAssistantFeature_index["WEB_ASSISTANT_FEATURE_UNSPECIFIED"] = 0] = "WEB_ASSISTANT_FEATURE_UNSPECIFIED";
    WebAssistantFeature_index[WebAssistantFeature_index["WEB_ASSISTANT_FEATURE_WEB_CONTACT"] = 1] = "WEB_ASSISTANT_FEATURE_WEB_CONTACT";
    WebAssistantFeature_index[WebAssistantFeature_index["WEB_ASSISTANT_FEATURE_ONLINE_SCHEDULING"] = 2] = "WEB_ASSISTANT_FEATURE_ONLINE_SCHEDULING";
})(WebAssistantFeature_index || (WebAssistantFeature_index = {}));
export const ScheduleSettingsService = {};
